import React from 'react'

export default function PaymentStats({
  loadingAllSalaries,
  loading,
  totalBonus,
  totalFines,
  totalWbDed,
  grandTotal,
  grandPaid,
  grandRemaining,
  avgSalaryData,
  payments,
  wbDeductions,
  employees,
  profile,
  isAdmin,
  allSalaries,
  filterEmployee,
  formatMoney,
  setStatDetailModal
}) {
  if (loadingAllSalaries || loading) {
    return (
      <div className="payments-stats" style={{ marginBottom: '20px' }}>
        {[0,1,2].map(i => (
          <div key={i} className="payments-stat-card" style={{ height: '112px', border: '1px solid var(--border-color)', borderRadius: '16px', padding: '16px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <div className="skeleton-pulse" style={{ width: '32px', height: '32px', borderRadius: '10px' }}></div>
            <div className="skeleton-pulse" style={{ width: '80px', height: '12px', borderRadius: '6px' }}></div>
            <div className="skeleton-pulse" style={{ width: '100px', height: '20px', borderRadius: '6px' }}></div>
          </div>
        ))}
      </div>
    )
  }

  // Safe checks for arrays and functions to prevent any TypeError: "x is not a function"
  const safePayments = Array.isArray(payments) ? payments : [];
  const safeWbDeductions = Array.isArray(wbDeductions) ? wbDeductions : [];
  const safeEmployees = Array.isArray(employees) ? employees : [];
  const safeAllSalaries = Array.isArray(allSalaries) ? allSalaries : [];
  const safeSetStatDetailModal = typeof setStatDetailModal === 'function' ? setStatDetailModal : () => {};

  return (
    <div className="payments-stats">
      <div
        className="payments-stat-card payments-stat-clickable"
        onClick={() => {
          safeSetStatDetailModal({
            title: 'Премии и бонусы',
            color: 'var(--success)',
            items: safePayments.filter(p => p.type === 'bonus' && p.status !== 'rejected').map(p => ({
              name: safeEmployees.find(e => e.id === p.employee_id)?.name || 'Сотрудник',
              amount: parseFloat(p.amount) || 0,
              comment: p.comment,
              date: p.period_start,
              rawRecord: { ...p, _source: 'payment' }
            })),
          });
        }}
      >
        <div className="payments-stat-icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg></div>
        <div className="payments-stat-label">Премии / Бонусы</div>
        <div className="payments-stat-value" style={{ color: 'var(--success)' }}>
          +{formatMoney(totalBonus)}
        </div>
        <div className="payments-stat-hint">Нажмите для деталей</div>
      </div>

      <div
        className="payments-stat-card payments-stat-clickable"
        onClick={() => {
          safeSetStatDetailModal({
            title: 'Штрафы и удержания',
            color: 'var(--danger)',
            items: [
              ...safePayments.filter(p => p.type === 'fine' && p.status !== 'rejected').map(p => ({
                name: safeEmployees.find(e => e.id === p.employee_id)?.name || 'Сотрудник',
                amount: parseFloat(p.amount) || 0,
                comment: p.comment || 'Штраф',
                date: p.period_start,
                badge: 'Штраф',
                rawRecord: { ...p, _source: 'payment' }
              })),
              ...safeWbDeductions.filter(d => d.status !== 'rejected').map(d => ({
                name: safeEmployees.find(e => e.id === d.employee_id)?.name || 'Сотрудник',
                amount: parseFloat(d.amount || 0) || 0,
                comment: d.reason || d.type || 'Удержание WB',
                date: d.date || d.period,
                badge: 'WB',
                rawRecord: { ...d, _source: 'deduction' }
              })),
            ],
          });
        }}
      >
        <div className="payments-stat-icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg></div>
        <div className="payments-stat-label">Штрафы + Удержания</div>
        <div className="payments-stat-value" style={{ color: 'var(--danger)' }}>
          −{formatMoney(totalFines + totalWbDed)}
        </div>
        <div className="payments-stat-hint">
          {totalFines > 0 && <span>Штрафы {formatMoney(totalFines)}</span>}
          {totalFines > 0 && totalWbDed > 0 && <span> + </span>}
          {totalWbDed > 0 && <span>WB {formatMoney(totalWbDed)}</span>}
          {totalFines === 0 && totalWbDed === 0 && <span>Нажмите для деталей</span>}
        </div>
      </div>

      <div
        className="payments-stat-card payments-stat-clickable payments-stat-total"
        onClick={() => {
          if (isAdmin && !filterEmployee) {
            safeSetStatDetailModal({
              title: 'Начислено за период по сотрудникам',
              color: 'var(--wb-primary)',
              items: safeAllSalaries.map(s => ({
                name: s.employeeName,
                amount: s.total || 0,
                comment: `${s.daysWorked} дн. / ${s.totalHours || 0}ч`,
                badge: safeEmployees.find(e => e.id === s.employeeId)?.pay_day != null ? ' Индив.' : null,
              })),
            });
          }
        }}
      >
        <div className="payments-stat-icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 3v18h18"/><path d="M18 17V9"/><path d="M13 17V5"/><path d="M8 17v-3"/></svg></div>
        <div className="payments-stat-label">
          {isAdmin && !filterEmployee ? 'Начислено за период' : 'Баланс корректировок'}
        </div>
        <div className="payments-stat-value" style={{ color: 'var(--wb-primary)' }}>
          {isAdmin && !filterEmployee
            ? formatMoney(grandTotal)
            : formatMoney(totalBonus - totalFines - totalWbDed)
          }
        </div>
        {isAdmin && !filterEmployee && (
          <div className="payments-stat-hint">На {safeAllSalaries.length} сотр.</div>
        )}
      </div>
    </div>
  )
}
